import RecentActorsIcon from '@mui/icons-material/RecentActors';
import ArticleIcon from '@mui/icons-material/Article';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import MenuIcon from '@mui/icons-material/Menu';
import NetworkWifi from '@mui/icons-material/NetworkWifi';
import PaidIcon from '@mui/icons-material/Paid';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import consts from '../../constant';
import logo from '../../Images/reglogo.png';
import TimelineIcon from '@mui/icons-material/Timeline';
import StoreIcon from '@mui/icons-material/Store';
import './Header.css';





const drawerWidth = 260;

function ResponsiveDrawer(props) {

    const [open, setOpen] = useState(false);
    const [openTradeHistory, setOpenTradeHistory] = useState(false);
    const [openStaking, setOpenStaking] = useState(false);
    const [p2p, setP2p] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    const handleClickTradeHistory = () => {
        setOpenTradeHistory(!openTradeHistory);
    };

    const handleClickStakingHistory = () => {
        setOpenStaking(!openStaking);
    };

    const [mobileOpen, setMobileOpen] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const result = useLocation();
    const pathDate = result.pathname


    const handleDrawerClose = () => {
        setIsClosing(true);
        setMobileOpen(false);
    };

    const handleDrawerTransitionEnd = () => {
        setIsClosing(false);
    };

    const handleDrawerToggle = () => {
        if (!isClosing) {
            setMobileOpen(!mobileOpen);
        }
    };

    const navigate = useNavigate()
    const drawer = (
        <div>
            <div className="logo-h">
                <img src={logo} alt="logo" />
            </div>
            {/* <Toolbar /> */}

            <Divider />
            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/dashboard'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <DashboardCustomizeIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Dashboard'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>
            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/userlist'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <RecentActorsIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'User List'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>
            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/kyc'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <ArticleIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'KYC'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>
            {/* <NavLink
                className={({ isActive }) => (isActive ? "bg-non" : "not-active")
                }
            // to={`/${consts.route +'/coinsettings'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton onClick={handleClick}>
                            <ListItemIcon>
                                <PaidIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Coin Settings'} />
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route + '/asset'}`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Asset" />
                                </ListItemButton>
                            </List>
                        </NavLink>
                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route + '/tradepair'}`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Trade Pair" />
                                </ListItemButton>
                            </List>
                        </NavLink>
                    </Collapse>
                </List>
            </NavLink> */}

            {/* <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/network'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <NetworkWifi style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Network'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink> */}

            <NavLink
                className={({ isActive }) => (isActive ? "bg-non" : "not-active")
                }
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton onClick={handleClickTradeHistory}>
                            <ListItemIcon>
                                <TimelineIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Trade History'} />
                            {openTradeHistory ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={openTradeHistory} timeout="auto" unmountOnExit>
                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/tradehistory?type=buy`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Buy Trade" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/tradehistory?type=sell`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Sell Trade" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/tradehistory?type=pending`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Pending Orders" />
                                </ListItemButton>
                            </List>
                        </NavLink>
                    </Collapse>
                </List>
            </NavLink>

            <NavLink
                className={({ isActive }) => (isActive ? "bg-non" : "not-active")
                }
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton onClick={() => (setP2p(!p2p))}>
                            <ListItemIcon>
                                <StoreIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'P2P Market Place'} />
                            {p2p ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>
                    <Collapse in={p2p} timeout="auto" unmountOnExit>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/p2p`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="P2P Pairs" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/p2pHistory?type=buy`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Buy Trade" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/p2pHistory?type=sell`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Sell Trade" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/raisedispute`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Raise Dispute" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                    </Collapse>
                </List>
            </NavLink>

            {/* <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/stakingList'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <AccountCircleIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'StakingHistory'} />
                        </ListItemButton>
                    </ListItem>
                </List>
            </NavLink> */}


            <NavLink
                className={({ isActive }) => (isActive ? "bg-non" : "not-active")
                }
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton onClick={handleClickStakingHistory}>
                            <ListItemIcon>
                                <TimelineIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Staking'} />
                            {openStaking ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                    </ListItem>

                    <Collapse in={openStaking} timeout="auto" unmountOnExit>
                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route}/stakingHistory`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Admin Staking Action" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route + '/stakingList'}`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Staking History" />
                                </ListItemButton>
                            </List>
                        </NavLink>

                        <NavLink
                            className={({ isActive }) => (isActive ? "active" : "not-active")
                            }
                            to={`/${consts.route + '/stakingBanner'}`}
                        >
                            <List component="div" disablePadding>
                                <ListItemButton sx={{ pl: 4 }}>
                                    <ListItemText primary="Staking Banner" />
                                </ListItemButton>
                            </List>
                        </NavLink>


                    </Collapse>
                </List>
            </NavLink>






            {/* <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/subadmin'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <HistoryIcon style={{ fill: '#fff' }} />
                                <img src={subadmin} />
                            </ListItemIcon>
                            <ListItemText primary={'SubAdmin'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink> */}

            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/userwithdrawhistry'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <ContactMailIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'User Withdraw History'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>



            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/affliate'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <ContactMailIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'User Affiliate History'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>

            <NavLink
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
                to={`/${consts.route + '/userDepositHistry'}`}
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <ContactMailIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'User Deposit History'} />
                        </ListItemButton>
                    </ListItem>

                </List>
            </NavLink>

            <NavLink

                to='/support'
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <SupportAgentIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'  Support'} />
                        </ListItemButton>
                    </ListItem>

                </List>


            </NavLink>


            <NavLink

                to='/landing'
                className={({ isActive }) => (isActive ? "active" : "not-active")
                }
            >
                <List>

                    <ListItem disablePadding>
                        <ListItemButton>
                            <ListItemIcon>
                                <UploadFileIcon style={{ fill: '#fff' }} />
                            </ListItemIcon>
                            <ListItemText primary={'Hero Section'} />
                        </ListItemButton>
                    </ListItem>

                </List>


            </NavLink>


        </div >
    );



    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar
                position="fixed"
                sx={{
                    width: { lg: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                className='appbar-head'
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { lg: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <div style={{ color: '#fff' }}>
                        Admin Panel
                    </div>
                    <div className="display-4 padding-10">

                        <div className="">

                            <button class="Btn" onClick={() => {
                                localStorage.removeItem("adminToken")
                                navigate(`/${consts.route + '/login'}`)
                            }}>

                                <div class="sign"><svg viewBox="0 0 512 512"><path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path></svg></div>

                                <div class="text">Logout</div>
                            </button>



                        </div>
                    </div>
                </Toolbar>


            </AppBar>
            <Box
                component="nav"
                sx={{ width: { lg: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Drawer

                    variant="temporary"
                    open={mobileOpen}
                    onTransitionEnd={handleDrawerTransitionEnd}
                    onClose={handleDrawerClose}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { md: 'block', lg: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    className='drawer-head'
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', lg: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                    open
                    className='drawer-head'
                >
                    {drawer}
                </Drawer>
            </Box>

        </Box>
    );
}



export default ResponsiveDrawer;
